import crossFetch, { Headers } from 'cross-fetch';
import OAuth from 'oauth-1.0a';
import Bottleneck from 'bottleneck';

var DataQualityEnum;
(function (DataQualityEnum) {
    DataQualityEnum["NEEDS_VOTE"] = "Needs Vote";
    DataQualityEnum["NEEDS_MINOR_CHANGE"] = "Needs Minor Changes";
    DataQualityEnum["CORRECT"] = "Correct";
})(DataQualityEnum || (DataQualityEnum = {}));
var CommunityStatusesEnum;
(function (CommunityStatusesEnum) {
    CommunityStatusesEnum["ACCEPTED"] = "Accepted";
})(CommunityStatusesEnum || (CommunityStatusesEnum = {}));

var ReleaseConditionsEnum;
(function (ReleaseConditionsEnum) {
    ReleaseConditionsEnum["MINT"] = "Mint (M)";
    ReleaseConditionsEnum["NEAR_MINT"] = "Near Mint (NM or M-)";
    ReleaseConditionsEnum["VERY_GOOD_PLUS"] = "Very Good Plus (VG+)";
    ReleaseConditionsEnum["VERY_GOOD"] = "Very Good (VG)";
    ReleaseConditionsEnum["GOOD_PLUS"] = "Good Plus (G+)";
    ReleaseConditionsEnum["GOOD"] = "Good (G)";
    ReleaseConditionsEnum["FAIR"] = "Fair (F)";
    ReleaseConditionsEnum["POOR"] = "Poor (P)";
})(ReleaseConditionsEnum || (ReleaseConditionsEnum = {}));
var SleeveConditionsEnum;
(function (SleeveConditionsEnum) {
    SleeveConditionsEnum["MINT"] = "Mint (M)";
    SleeveConditionsEnum["NEAR_MINT"] = "Near Mint (NM or M-)";
    SleeveConditionsEnum["VERY_GOOD_PLUS"] = "Very Good Plus (VG+)";
    SleeveConditionsEnum["VERY_GOOD"] = "Very Good (VG)";
    SleeveConditionsEnum["GOOD_PLUS"] = "Good Plus (G+)";
    SleeveConditionsEnum["GOOD"] = "Good (G)";
    SleeveConditionsEnum["FAIR"] = "Fair (F)";
    SleeveConditionsEnum["POOR"] = "Poor (P)";
    SleeveConditionsEnum["GENERIC"] = "Generic";
    SleeveConditionsEnum["NOT_GRADED"] = "Not Graded";
    SleeveConditionsEnum["NO_COVER"] = "No Cover";
})(SleeveConditionsEnum || (SleeveConditionsEnum = {}));

var CurrenciesEnum;
(function (CurrenciesEnum) {
    CurrenciesEnum["USD"] = "USD";
    CurrenciesEnum["GBP"] = "GBP";
    CurrenciesEnum["EUR"] = "EUR";
    CurrenciesEnum["CAD"] = "CAD";
    CurrenciesEnum["AUD"] = "AUD";
    CurrenciesEnum["JPY"] = "JPY";
    CurrenciesEnum["CHF"] = "CHF";
    CurrenciesEnum["MXN"] = "MXN";
    CurrenciesEnum["BRL"] = "BRL";
    CurrenciesEnum["NZD"] = "NZD";
    CurrenciesEnum["SEK"] = "SEK";
    CurrenciesEnum["ZAR"] = "ZAR";
})(CurrenciesEnum || (CurrenciesEnum = {}));

var FolderIdsEnum;
(function (FolderIdsEnum) {
    FolderIdsEnum[FolderIdsEnum["ALL"] = 0] = "ALL";
    FolderIdsEnum[FolderIdsEnum["UNCATEGORIZED"] = 1] = "UNCATEGORIZED";
})(FolderIdsEnum || (FolderIdsEnum = {}));

var InventoryStatusesEnum;
(function (InventoryStatusesEnum) {
    InventoryStatusesEnum["ALL"] = "All";
    InventoryStatusesEnum["DELETED"] = "Deleted";
    InventoryStatusesEnum["DRAFT"] = "Draft";
    InventoryStatusesEnum["EXPIRED"] = "Expired";
    InventoryStatusesEnum["FOR_SALE"] = "For Sale";
    InventoryStatusesEnum["SOLD"] = "Sold";
    InventoryStatusesEnum["SUSPENDED"] = "Suspended";
    InventoryStatusesEnum["VIOLATION"] = "Violation";
})(InventoryStatusesEnum || (InventoryStatusesEnum = {}));
var InventorySortEnum;
(function (InventorySortEnum) {
    InventorySortEnum["LISTED"] = "listed";
    InventorySortEnum["PRICE"] = "price";
    InventorySortEnum["ITEM"] = "item";
    InventorySortEnum["ARTIST"] = "artist";
    InventorySortEnum["LABEL"] = "label";
    InventorySortEnum["CATNO"] = "catno";
    InventorySortEnum["AUDIO"] = "audio";
    InventorySortEnum["STATUS"] = "status";
    InventorySortEnum["LOCATION"] = "location";
})(InventorySortEnum || (InventorySortEnum = {}));

var ListingStatusesEnum;
(function (ListingStatusesEnum) {
    ListingStatusesEnum["FOR_SALE"] = "For Sale";
    ListingStatusesEnum["DRAFT"] = "Draft";
})(ListingStatusesEnum || (ListingStatusesEnum = {}));

var EditOrderStatusesEnum;
(function (EditOrderStatusesEnum) {
    EditOrderStatusesEnum["NEW_ORDER"] = "New Order";
    EditOrderStatusesEnum["BUYER_CONTACTER"] = "Buyer Contacted";
    EditOrderStatusesEnum["INVOICE_SENT"] = "Invoice Sent";
    EditOrderStatusesEnum["PAYMENT_PENDING"] = "Payment Pending";
    EditOrderStatusesEnum["PAYMENT_RECEIVED"] = "Payment Received";
    EditOrderStatusesEnum["SHIPPED"] = "Shipped";
    EditOrderStatusesEnum["REFUND_SENT"] = "Refund Sent";
    EditOrderStatusesEnum["CANCELLED_NON_PAYING_BUYER"] = "Cancelled (Non-Paying Buyer)";
    EditOrderStatusesEnum["CANCELLED_ITEM_UNAVAILABLE"] = "Cancelled (Item Unavailable)";
    EditOrderStatusesEnum["CANCELLED_PER_BUYER_REQUEST"] = "Cancelled (Per Buyer's Request)";
})(EditOrderStatusesEnum || (EditOrderStatusesEnum = {}));
var OrderStatusesEnum;
(function (OrderStatusesEnum) {
    OrderStatusesEnum["ALL"] = "All";
    OrderStatusesEnum["NEW_ORDER"] = "New Order";
    OrderStatusesEnum["BUYER_CONTACTED"] = "Buyer Contacted";
    OrderStatusesEnum["INVOICE_SENT"] = "Invoice Sent";
    OrderStatusesEnum["PAYMENT_PENDING"] = "Payment Pending";
    OrderStatusesEnum["PAYMENT_RECEIVED"] = "Payment Received";
    OrderStatusesEnum["SHIPPED"] = "Shipped";
    OrderStatusesEnum["MERGED"] = "Merged";
    OrderStatusesEnum["ORDER_CHANGED"] = "Order Changed";
    OrderStatusesEnum["REFUND_SENT"] = "Refund Sent";
    OrderStatusesEnum["CANCELLED"] = "Cancelled";
    OrderStatusesEnum["CANCELLED_NON_PAYING_BUYER"] = "Cancelled (Non-Paying Buyer)";
    OrderStatusesEnum["CANCELLED_ITEM_UNAVAILABLE"] = "Cancelled (Item Unavailable)";
    OrderStatusesEnum["CANCELLED_PER_BUYER_REQUEST"] = "Cancelled (Per Buyer's Request)";
    OrderStatusesEnum["CANCELLED_REFUND_RECEIVED"] = "Cancelled (Refund Received)";
})(OrderStatusesEnum || (OrderStatusesEnum = {}));
var OrderSortEnum;
(function (OrderSortEnum) {
    OrderSortEnum["ID"] = "id";
    OrderSortEnum["BUYER"] = "buyer";
    OrderSortEnum["CREATED"] = "created";
    OrderSortEnum["STATUS"] = "status";
    OrderSortEnum["LAST_ACTIVITY"] = "last_activity";
})(OrderSortEnum || (OrderSortEnum = {}));
var OrderMessageTypesEnum;
(function (OrderMessageTypesEnum) {
    OrderMessageTypesEnum["STATUS"] = "status";
    OrderMessageTypesEnum["MESSAGE"] = "message";
    OrderMessageTypesEnum["SHIPPING"] = "shipping";
    OrderMessageTypesEnum["REFUND_SENT"] = "refund_sent";
    OrderMessageTypesEnum["REFUND_RECEIVED"] = "refund_received";
})(OrderMessageTypesEnum || (OrderMessageTypesEnum = {}));

var ReleaseSortEnum;
(function (ReleaseSortEnum) {
    ReleaseSortEnum["YEAR"] = "year";
    ReleaseSortEnum["TITLE"] = "title";
    ReleaseSortEnum["FORMAT"] = "format";
})(ReleaseSortEnum || (ReleaseSortEnum = {}));

var SearchTypeEnum;
(function (SearchTypeEnum) {
    SearchTypeEnum["RELEASE"] = "release";
    SearchTypeEnum["MASTER"] = "master";
    SearchTypeEnum["ARTIST"] = "artist";
    SearchTypeEnum["LABEL"] = "label";
})(SearchTypeEnum || (SearchTypeEnum = {}));

var UserSortEnum;
(function (UserSortEnum) {
    UserSortEnum["LABEL"] = "label";
    UserSortEnum["ARTIST"] = "artist";
    UserSortEnum["TITLE"] = "title";
    UserSortEnum["CATNO"] = "catno";
    UserSortEnum["FORMAT"] = "format";
    UserSortEnum["RATING"] = "rating";
    UserSortEnum["YEAR"] = "year";
    UserSortEnum["ADDED"] = "added";
})(UserSortEnum || (UserSortEnum = {}));

// https://www.typescriptlang.org/docs/handbook/mixins.html
function applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null));
        });
    });
}

class AuthError extends Error {
    name;
    message;
    statusCode;
    constructor() {
        super();
        this.name = 'AuthError';
        this.message = 'Unauthorized';
        this.statusCode = 401;
        Object.setPrototypeOf(this, AuthError.prototype);
    }
}

class DiscogsError extends Error {
    message;
    name;
    statusCode;
    /**
     * Seconds to wait before retrying, from the response's `Retry-After`. Present
     * only when the server sent one -- generally on a 429.
     */
    retryAfter;
    constructor(message, code, retryAfter) {
        super(message);
        this.message = message;
        this.name = 'DiscogsError';
        this.statusCode = code;
        this.retryAfter = retryAfter;
        Object.setPrototypeOf(this, DiscogsError.prototype);
    }
}

/**
 * Type guard to check if authenticated thanks to user token.
 *
 * @internal
 */
function isAuthenticatedWithToken(options) {
    return !!options && 'userToken' in options && typeof options.userToken === 'string';
}
/**
 * Type guard to check if authenticated thanks to consumer key.
 *
 * @internal
 */
function isAuthenticatedWithConsumerKey(options) {
    return (!!options &&
        'consumerKey' in options &&
        typeof options.consumerKey === 'string' &&
        'consumerSecret' in options &&
        typeof options.consumerSecret === 'string' &&
        'oAuthToken' in options &&
        typeof options.oAuthToken === 'string' &&
        'oAuthTokenSecret' in options &&
        typeof options.oAuthTokenSecret === 'string');
}
/**
 * Type guard to check whether requests are authenticated or not.
 *
 * @internal
 */
function isAuthenticated(options) {
    return isAuthenticatedWithToken(options) || isAuthenticatedWithConsumerKey(options);
}
/**
 * Helper to create a function to set the Authorization header based on the authentication strategy.
 *
 * @internal
 */
function makeSetAuthorizationHeader(options) {
    if (isAuthenticatedWithToken(options))
        return () => `Discogs token=${options.userToken}`;
    if (isAuthenticatedWithConsumerKey(options)) {
        const oAuth = new OAuth({
            consumer: { key: options.consumerKey, secret: options.consumerSecret },
            signature_method: 'PLAINTEXT',
            version: '1.0',
        });
        return (url, method) => {
            if (!url || !method)
                return '';
            const authObject = oAuth.authorize({ url, method }, { key: options.oAuthToken, secret: options.oAuthTokenSecret });
            return oAuth.toHeader(authObject).Authorization;
        };
    }
    return undefined;
}

/**
 * Helper to create a new instance of Bottleneck.
 *
 * @internal
 */
function createLimiter({ maxRequests, requestLimitInterval, maxConcurrent = 1 }) {
    return new Bottleneck({
        maxConcurrent,
        minTime: requestLimitInterval / maxRequests,
        reservoir: maxRequests,
        reservoirRefreshAmount: maxRequests,
        reservoirRefreshInterval: requestLimitInterval,
    });
}

/** Base API URL to which URI will be appended. */
const API_BASE_URL = 'https://api.discogs.com';
/** Base URL dedicated to Discogs images. */
const IMG_BASE_URL = 'https://img.discogs.com';
/** Discogs API version. */
const API_VERSION = 'v2';
/** Default user-agent to be used in requests. */
const DEFAULT_USER_AGENT = `Discojs/2.3.1`;
/** Header set by Discogs API to indicate the total number of requests you can make in a one minute window. */
const RATE_LIMIT_HEADER = 'X-Discogs-Ratelimit';
/** Header set by Discogs API to indicate the number of remaining requests you are able to make in the existing rate limit window. */
const RATE_LIMIT_REMAINING_HEADER = 'X-Discogs-Ratelimit-Remaining';
/** Header set by Discogs API to indicate the number of requests made in the existing rate limit window. */
const RATE_LIMIT_USED_HEADER = 'X-Discogs-Ratelimit-Used';
/** Standard header naming how long to wait before retrying. Discogs does not currently send one on 429. */
const RETRY_AFTER_HEADER = 'Retry-After';
/**
 * HTTP verbs.
 *
 * @internal
 */
var HTTPVerbsEnum;
(function (HTTPVerbsEnum) {
    HTTPVerbsEnum["GET"] = "GET";
    HTTPVerbsEnum["POST"] = "POST";
    HTTPVerbsEnum["PUT"] = "PUT";
    HTTPVerbsEnum["DELETE"] = "DELETE";
})(HTTPVerbsEnum || (HTTPVerbsEnum = {}));
class Fetcher {
    userAgent;
    outputFormat;
    headers;
    setAuthorizationHeader;
    options;
    apiBaseUrl;
    maxRequests;
    reservoirRefreshInterval;
    limiter;
    cache;
    onRateLimit;
    constructor(options) {
        const { requestLimit = 25, requestLimitAuth = 60, requestLimitInterval = 60 * 1000, maxConcurrent = 1, userAgent = DEFAULT_USER_AGENT, outputFormat = 'discogs', fetchOptions = {}, cache = undefined, allowUnsafeHeaders = true, apiBaseUrl = API_BASE_URL, onRateLimit = undefined, } = options || {};
        // Tolerate a trailing slash; every call site concatenates a path beginning with one.
        this.apiBaseUrl = apiBaseUrl.replace(/\/+$/, '');
        this.userAgent = userAgent;
        this.outputFormat = outputFormat;
        const unsafeHeadersInit = allowUnsafeHeaders
            ? {
                'Accept-Encoding': 'gzip,deflate',
                Connection: 'close',
                'User-Agent': userAgent,
            }
            : {};
        this.headers = new Headers({
            Accept: `application/vnd.discogs.${API_VERSION}.${outputFormat}+json`,
            'Content-Type': 'application/json',
            ...unsafeHeadersInit,
        });
        this.setAuthorizationHeader = makeSetAuthorizationHeader(options);
        this.options = fetchOptions;
        this.maxRequests = isAuthenticated(options) ? requestLimitAuth : requestLimit;
        this.reservoirRefreshInterval = requestLimitInterval;
        this.limiter = createLimiter({
            maxRequests: this.maxRequests,
            requestLimitInterval: this.reservoirRefreshInterval,
            maxConcurrent,
        });
        this.cache = cache;
        this.onRateLimit = onRateLimit;
    }
    updateMaxRequests(maxRequests) {
        this.limiter.updateSettings({
            minTime: this.reservoirRefreshInterval / maxRequests,
            reservoir: maxRequests,
            reservoirRefreshAmount: maxRequests,
        });
    }
    updateRemainingRequests(remainingRequests) {
        this.limiter.updateSettings({ reservoir: remainingRequests });
    }
    /** `parseInt` that yields undefined rather than NaN for an absent or junk header. */
    static readNumber(headers, name) {
        const value = parseInt(headers.get(name) ?? '', 10);
        return Number.isNaN(value) ? undefined : value;
    }
    handleRateLimitHeaders(url, status, headers) {
        const rateLimit = Fetcher.readNumber(headers, RATE_LIMIT_HEADER);
        const rateLimitRemaining = Fetcher.readNumber(headers, RATE_LIMIT_REMAINING_HEADER);
        // Update max requests only if lower than the current value.
        if (rateLimit !== undefined && rateLimit < this.maxRequests) {
            this.updateMaxRequests(rateLimit);
        }
        if (rateLimitRemaining !== undefined) {
            this.updateRemainingRequests(rateLimitRemaining);
        }
        const retryAfter = Fetcher.readNumber(headers, RETRY_AFTER_HEADER);
        if (this.onRateLimit) {
            try {
                this.onRateLimit({
                    limit: rateLimit,
                    used: Fetcher.readNumber(headers, RATE_LIMIT_USED_HEADER),
                    remaining: rateLimitRemaining,
                    retryAfter,
                    status,
                    url,
                    at: Date.now(),
                });
            }
            catch {
                // A consumer's reporting hook must not be able to fail their request.
            }
        }
        return retryAfter;
    }
    async fetch(url, options, shouldReturnBlob) {
        const response = await crossFetch(url, options);
        const { status, statusText, headers } = response;
        // Deliberately before the status checks below, so the numbers are reported for
        // error responses too -- a 429 is precisely when a consumer most wants them.
        const retryAfter = this.handleRateLimitHeaders(url, status, headers);
        // Check status
        if (status === 401) {
            throw new AuthError();
        }
        if (status === 422 || status >= 500) {
            const { message, detail } = await response.json();
            const errorMessage = detail ? detail.map((e) => `${e.loc.join('.')}: ${e.msg} (${e.type})`).join('\n') : message;
            throw new DiscogsError(errorMessage, status);
        }
        if (status < 200 || status >= 300) {
            throw new DiscogsError(statusText, status, retryAfter);
        }
        if (status === 204) {
            return Promise.resolve({});
        }
        if (shouldReturnBlob) {
            const blob = await response.blob();
            return blob;
        }
        const data = await response.json();
        return data;
    }
    /**
     * Method used within other methods to schedule fetching from the Discogs API.
     *
     * @internal
     */
    async schedule(uri, query, method, data) {
        const isImgEndpoint = uri.startsWith(IMG_BASE_URL);
        const path = query && typeof query === 'object' ? Fetcher.addQueryToUri(uri, query) : uri;
        // Two URLs, deliberately.
        //
        // `endpoint` is the request's canonical identity and is what `cache` is keyed on;
        // `requestUrl` is where it actually goes. They diverge only when `apiBaseUrl` points
        // somewhere else. Keeping the cache key canonical means switching to a proxy neither
        // invalidates a consumer's cache nor changes what its cache-clearing patterns match.
        //
        // Note the auth header is signed over the *relative* `uri` below, and the PLAINTEXT
        // signature (`consumerSecret&tokenSecret`) does not cover the URL at all, so this
        // split is signature-safe. It would stop being so under HMAC-SHA1.
        const endpoint = isImgEndpoint ? uri : API_BASE_URL + path;
        const requestUrl = isImgEndpoint ? uri : this.apiBaseUrl + path;
        const isCsvEndpoint = uri.endsWith('/download');
        const options = {
            ...this.options,
            method: method || HTTPVerbsEnum.GET,
        };
        // Set Authorization header.
        if (this.setAuthorizationHeader)
            this.headers.set('Authorization', this.setAuthorizationHeader(uri, method || HTTPVerbsEnum.GET));
        const clonedHeaders = new Map(this.headers);
        if (data) {
            const stringifiedData = JSON.stringify(Fetcher.transformData(data));
            options.body = stringifiedData;
            // Header names must be set in lower case here: `clonedHeaders` was built by iterating a
            // `Headers`, which lower-cases the names it yields, and a `Map` keyed `content-type` happily
            // takes a second `Content-Type` entry. `Object.fromEntries` keeps both, and fetch then joins
            // them into `content-type: application/json, application/json`, which Discogs rejects.
            clonedHeaders.set('content-type', 'application/json');
            // `Content-Length` is a forbidden header name in browsers — the user agent computes it — and
            // `Buffer` only exists on Node, where referencing it in a bundled browser build throws a
            // `ReferenceError`. Set it only where it is both available and honoured.
            if (typeof Buffer !== 'undefined') {
                clonedHeaders.set('content-length', Buffer.byteLength(stringifiedData, 'utf8').toString());
            }
        }
        options.headers = Object.fromEntries(clonedHeaders);
        const execute = () => this.limiter.schedule(() => this.fetch(requestUrl, options, isImgEndpoint || isCsvEndpoint));
        return this.cache?.get(execute, endpoint, options) ?? execute();
    }
    /**
     * Helper to add query to a URI. Strips undefined values.
     *
     * @param uri - Endpoint to which query will be appended.
     * @param query
     * @returns URI + query
     *
     * @internal
     */
    static addQueryToUri(uri, query) {
        const params = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
            if (typeof value !== 'undefined') {
                params.append(key, value);
            }
        });
        return `${uri}?${params.toString()}`;
    }
    /**
     * Helper to transform camelcased data keys to snakecased one and rename `currency` to `curr_abbr`.
     *
     * @param data
     * @returns Tranformed `data` object.
     *
     * @internal
     */
    static transformData(data) {
        return Object.entries(data).reduce((acc, [key, value]) => ({
            ...acc,
            [key === 'currency' ? 'curr_abbr' : key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)]: value,
        }), {});
    }
    async *createAllMethod(fetchFunction) {
        let currentPage = 1;
        let lastPage = 1;
        do {
            const { pagination, ...data } = await fetchFunction({
                page: currentPage,
                perPage: 100, // Use maximum value to reduce the number of requests.
            });
            lastPage = pagination.pages;
            yield data;
            currentPage += 1;
        } while (currentPage <= lastPage);
    }
}

const DEFAULT_PAGE = 1;
const DEFAULT_PER_PAGE = 50;
/**
 * Paginate helper.
 *
 * @internal
 */
function paginate(options) {
    const { page = DEFAULT_PAGE, perPage = DEFAULT_PER_PAGE } = options || {};
    return {
        // Minimum page is 1
        page: Math.max(DEFAULT_PAGE, page),
        // Maximum items per page are 100
        per_page: perPage <= 0 || perPage > 100 ? DEFAULT_PER_PAGE : perPage,
    };
}

var SortOrdersEnum;
(function (SortOrdersEnum) {
    SortOrdersEnum["ASC"] = "asc";
    SortOrdersEnum["DESC"] = "desc";
})(SortOrdersEnum || (SortOrdersEnum = {}));
/**
 * Sort by helper.
 *
 * @internal
 */
function sortBy(defaultSortBy, options) {
    const { by = defaultSortBy, order = SortOrdersEnum.ASC } = options || {};
    return {
        sort: by,
        sort_order: order,
    };
}

class Database {
    /**
     * Get a release.
     *
     * @category Database
     * @label Release
     *
     * @link https://www.discogs.com/developers#page:database,header:database-release
     */
    async getRelease(releaseId, currency) {
        return this.fetcher.schedule(`/releases/${releaseId}`, { currency });
    }
    /**
     * Retrieves the release’s rating for a given user.
     *
     * @category Database
     * @label Release Rating
     *
     * @link https://www.discogs.com/developers#page:database,header:database-release-rating-by-user
     */
    async getReleaseRatingForUser(username, releaseId) {
        return this.fetcher.schedule(`/releases/${releaseId}/rating/${username}`);
    }
    /**
     * Retrieves the release’s rating for the authenticated user.
     *
     * @category Database
     * @label Release Rating
     *
     * @link https://www.discogs.com/developers#page:database,header:database-release-rating-by-user
     */
    async getReleaseRating(releaseId) {
        const username = await this.getUsername();
        return this.getReleaseRatingForUser(username, releaseId);
    }
    /**
     * Updates the release’s rating for the authenticated user.
     *
     * @category Database
     * @label Release Rating
     *
     * @link https://www.discogs.com/developers#page:database,header:database-release-rating-by-user
     */
    async updateReleaseRating(releaseId, rating) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/releases/${releaseId}/rating/${username}`, {}, HTTPVerbsEnum.PUT, { rating });
    }
    /**
     * Deletes the release’s rating for the authenticated user.
     *
     * @category Database
     * @label Release Rating
     *
     * @link https://www.discogs.com/developers#page:database,header:database-release-rating-by-user
     */
    async deleteReleaseRating(releaseId) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/releases/${releaseId}/rating/${username}`, {}, HTTPVerbsEnum.DELETE);
    }
    /**
     * Retrieves the community release rating average and count.
     *
     * @category Database
     * @label Community Release Rating
     *
     * @link https://www.discogs.com/developers#page:database,header:database-community-release-rating
     */
    async getCommunityReleaseRating(releaseId) {
        return this.fetcher.schedule(`/releases/${releaseId}/rating`);
    }
    /**
     * Retrieves the total number of “haves” (in the community’s collections) and “wants” (in the community’s wantlists) for a given release.
     *
     * @category Database
     * @label Release Stats
     *
     * @link https://www.discogs.com/developers#page:database,header:database-release-stats
     *
     * Note: This endpoint is broken, see link below for a workaround.
     * @link https://www.discogs.com/fr/forum/thread/865093?message_id=8630743
     */
    async getReleaseStats(releaseId) {
        const { community } = await this.getRelease(releaseId);
        return {
            num_have: community.have,
            num_want: community.want,
        };
    }
    /**
     * Get a master release.
     *
     * @category Database
     * @label Master Release
     *
     * @link https://www.discogs.com/developers#page:database,header:database-master-release
     */
    async getMaster(masterId) {
        return this.fetcher.schedule(`/masters/${masterId}`);
    }
    /**
     * Retrieves a list of all releases that are versions of a master.
     *
     * @category Database
     * @label Master Release Versions
     *
     * @link https://www.discogs.com/developers#page:database,header:database-master-release-versions
     */
    // @TODO: There are a lot of parameters not handled here
    async getMasterVersions(masterId, pagination) {
        return this.fetcher.schedule(`/masters/${masterId}/versions`, paginate(pagination));
    }
    /**
     * Retrieves all releases that are versions of a master.
     *
     * @category Database
     * @label Master Release Versions
     *
     * @link https://www.discogs.com/developers#page:database,header:database-master-release-versions
     */
    getAllMasterVersions(masterId) {
        return this.fetcher.createAllMethod((pagination) => this.getMasterVersions(masterId, pagination));
    }
    /**
     * Get an artist.
     *
     * @category Database
     * @label Artist
     *
     * @link https://www.discogs.com/developers#page:database,header:database-artist
     */
    async getArtist(artistId) {
        return this.fetcher.schedule(`/artists/${artistId}`);
    }
    /**
     * Returns a list of releases and masters associated with an artist.
     *
     * @category Database
     * @label Artist Releases
     *
     * @link https://www.discogs.com/developers#page:database,header:database-artist-releases
     */
    async getArtistReleases(artistId, sort, pagination) {
        return this.fetcher.schedule(`/artists/${artistId}/releases`, {
            ...sortBy(ReleaseSortEnum.YEAR, sort),
            ...paginate(pagination),
        });
    }
    /**
     * Returns all releases and masters associated with an artist.
     *
     * @category Database
     * @label Artist Releases
     *
     * @link https://www.discogs.com/developers#page:database,header:database-artist-releases
     */
    getAllArtistReleases(artistId, sort) {
        return this.fetcher.createAllMethod((pagination) => this.getArtistReleases(artistId, sort, pagination));
    }
    /**
     * Get a label.
     *
     * @category Database
     * @label Label
     *
     * @link https://www.discogs.com/developers#page:database,header:database-label
     */
    async getLabel(labelId) {
        return this.fetcher.schedule(`/labels/${labelId}`);
    }
    /**
     * Returns a list of releases associated with the label.
     *
     * @category Database
     * @label Label Releases
     *
     * @link https://www.discogs.com/developers#page:database,header:database-all-label-releases
     */
    async getLabelReleases(labelId, pagination) {
        return this.fetcher.schedule(`/labels/${labelId}/releases`, paginate(pagination));
    }
    /**
     * Returns all releases associated with the label.
     *
     * @category Database
     * @label Label Releases
     *
     * @link https://www.discogs.com/developers#page:database,header:database-all-label-releases
     */
    getAllLabelReleases(labelId) {
        return this.fetcher.createAllMethod((pagination) => this.getLabelReleases(labelId, pagination));
    }
    /**
     * Issue a search query to Discogs database.
     *
     * @category Database
     * @label Search
     *
     * @link https://www.discogs.com/developers#page:database,header:database-search
     */
    async searchDatabase(options = {}, pagination) {
        return this.fetcher.schedule('/database/search', { ...options, ...paginate(pagination) });
    }
    /**
     * Search for a release.
     *
     * @category Database
     * @label Search
     *
     * @link https://www.discogs.com/developers#page:database,header:database-search
     */
    async searchRelease(query, options = {}, pagination) {
        return this.searchDatabase({ ...options, query, type: SearchTypeEnum.RELEASE }, pagination);
    }
    /**
     * Search for a master release.
     *
     * @category Database
     * @label Search
     *
     * @link https://www.discogs.com/developers#page:database,header:database-search
     */
    async searchMaster(query, options = {}, pagination) {
        return this.searchDatabase({ ...options, query, type: SearchTypeEnum.MASTER }, pagination);
    }
    /**
     * Search for an artist.
     *
     * @category Database
     * @label Search
     *
     * @link https://www.discogs.com/developers#page:database,header:database-search
     */
    async searchArtist(query, options = {}, pagination) {
        return this.searchDatabase({ ...options, query, type: SearchTypeEnum.ARTIST }, pagination);
    }
    /**
     * Search for a label.
     *
     * @category Database
     * @label Search
     *
     * @link https://www.discogs.com/developers#page:database,header:database-search
     */
    async searchLabel(query, options = {}, pagination) {
        return this.searchDatabase({ ...options, query, type: SearchTypeEnum.LABEL }, pagination);
    }
}

class InventoryExport {
    /**
     * Request an export of your inventory as a CSV.
     *
     * @category Inventory Export
     * @label Export your inventory
     *
     * @link https://www.discogs.com/developers#page:inventory-export,header:inventory-export-export-your-inventory
     */
    async requestInventoryExport() {
        return this.fetcher.schedule('/inventory/export', undefined, HTTPVerbsEnum.POST);
    }
    /**
     * Get a list of all recent exports of your inventory.
     *
     * @category Inventory Export
     * @label Get recent exports
     *
     * @link https://www.discogs.com/developers#page:inventory-export,header:inventory-export-get-recent-exports
     */
    async getRecentExports(pagination) {
        return this.fetcher.schedule('/inventory/export', paginate(pagination));
    }
    /**
     * Get all recent exports of your inventory.
     *
     * @category Inventory Export
     * @label Get recent exports
     *
     * @link https://www.discogs.com/developers#page:inventory-export,header:inventory-export-get-recent-exports
     */
    getAllRecentExports() {
        return this.fetcher.createAllMethod((pagination) => this.getRecentExports(pagination));
    }
    /**
     * Get details about the status of an inventory export.
     *
     * @category Inventory Export
     * @label Get an export
     *
     * @link https://www.discogs.com/developers#page:inventory-export,header:inventory-export-get-an-export
     */
    async getExport(exportId) {
        return this.fetcher.schedule(`/inventory/export/${exportId}`);
    }
    /**
     * Download the results of an inventory export.
     *
     * @category Inventory Export
     * @label Download an export
     *
     * @link https://www.discogs.com/developers#page:inventory-export,header:inventory-export-download-an-export
     */
    async downloadExport(exportId) {
        return this.fetcher.schedule(`/inventory/export/${exportId}/download`);
    }
}

// @TODO: Introduce methods.
class InventoryUpload {
}

class MarketPlace {
    /**
     * Get a seller’s inventory.
     *
     * @remarks
     * If you are not authenticated as the inventory owner, only items that have a status of For Sale will be visible.
     * If you are authenticated as the inventory owner you will get additional weight, format_quantity, external_id, and location keys.
     * If the user is authorized, the listing will contain a `in_cart` boolean field indicating whether or not this listing is in their cart.
     *
     * @category Marketplace
     * @label Inventory
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-inventory
     */
    async getInventoryForUser(username, status = InventoryStatusesEnum.ALL, sort, pagination) {
        return this.fetcher.schedule(`/users/${username}/inventory`, {
            status,
            ...sortBy(InventorySortEnum.LISTED, sort),
            ...paginate(pagination),
        });
    }
    /**
     * Get all seller’s inventory.
     *
     * @category Marketplace
     * @label Inventory
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-inventory
     */
    getAllInventoryForUser(username, status = InventoryStatusesEnum.ALL, sort) {
        return this.fetcher.createAllMethod((pagination) => this.getInventoryForUser(username, status, sort, pagination));
    }
    /**
     * Get authenticated user’s inventory.
     *
     * @category Marketplace
     * @label Inventory
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-inventory
     */
    async getInventory(status, sort, pagination) {
        const username = await this.getUsername();
        // Authenticated as the inventory owner, so Discogs always returns the owner-only keys.
        return this.getInventoryForUser(username, status, sort, pagination);
    }
    /**
     * Get all authenticated user’s inventory.
     *
     * @category Marketplace
     * @label Inventory
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-inventory
     */
    getAllInventory(status, sort) {
        return this.fetcher.createAllMethod((pagination) => this.getInventory(status, sort, pagination));
    }
    /**
     * View the data associated with a listing.
     *
     * @remarks
     * If the authorized user is the listing owner the listing will include the weight, format_quantity, external_id, and location keys.
     * If the user is authorized, the listing will contain a in_cart boolean field indicating whether or not this listing is in their cart.
     *
     * @category Marketplace
     * @label Listing
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-listing
     */
    async getListing(listingId, currency) {
        return this.fetcher.schedule(`/marketplace/listings/${listingId}`, { currency });
    }
    /**
     * Edit the data associated with a listing.
     *
     * @remarks
     * If the listing’s status is not For Sale, Draft, or Expired, it cannot be modified – only deleted.
     *
     * @category Marketplace
     * @label Listing
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-listing
     */
    async editListing(listingId, options, currency) {
        return this.fetcher.schedule(`/marketplace/listings/${listingId}`, { currency }, HTTPVerbsEnum.POST, options);
    }
    /**
     * Permanently remove a listing from the Marketplace.
     *
     * @category Marketplace
     * @label Listing
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-listing
     */
    async deleteListing(listingId) {
        return this.fetcher.schedule(`/marketplace/listings/${listingId}`, {}, HTTPVerbsEnum.DELETE);
    }
    /**
     * Create a Marketplace listing.
     *
     * @category Marketplace
     * @label New Listing
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-new-listing
     */
    async createListing(options) {
        return this.fetcher.schedule('/marketplace/listings/', {}, HTTPVerbsEnum.POST, options);
    }
    /**
     * View the data associated with an order.
     *
     * @category Marketplace
     * @label Order
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-order
     */
    async getOrder(orderId) {
        return this.fetcher.schedule(`/marketplace/orders/${orderId}`);
    }
    /**
     * Edit the data associated with an order.
     *
     * @category Marketplace
     * @label Order
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-order
     */
    async editOrder(orderId, status, shipping) {
        return this.fetcher.schedule(`/marketplace/orders/${orderId}`, {}, HTTPVerbsEnum.POST, { status, shipping });
    }
    /**
     * Returns a list of the authenticated user’s orders.
     *
     * @category Marketplace
     * @label List Orders
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-list-orders
     */
    async listOrders(status, archived, sort, pagination) {
        return this.fetcher.schedule('/marketplace/orders', {
            status,
            archived,
            ...sortBy(OrderSortEnum.ID, sort),
            ...paginate(pagination),
        });
    }
    /**
     * Returns all authenticated user’s orders.
     *
     * @category Marketplace
     * @label List Orders
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-list-orders
     */
    listAllOrders(status, archived, sort) {
        return this.fetcher.createAllMethod((pagination) => this.listOrders(status, archived, sort, pagination));
    }
    /**
     * Returns a list of the order’s messages with the most recent first.
     *
     * @category Marketplace
     * @label Order Messages
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-list-order-messages
     */
    async listOrderMessages(orderId) {
        return this.fetcher.schedule(`/marketplace/orders/${orderId}/messages`);
    }
    /**
     * Adds a new message to the order’s message log.
     *
     * @remarks
     * When posting a new message, you can simultaneously change the order status.
     * If you do, the message will automatically be prepended with: "Seller changed status from `Old Status` to `New Status`"
     * While message and status are each optional, one or both must be present.
     *
     * @category Marketplace
     * @label Order Messages
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-list-order-messages
     */
    async sendOrderMessage(orderId, message, status) {
        return this.fetcher.schedule(`/marketplace/orders/${orderId}/messages`, {}, HTTPVerbsEnum.POST, {
            message,
            status,
        });
    }
    /**
     * The Fee resource allows you to quickly calculate the fee for selling an item on the Marketplace.
     *
     * @category Marketplace
     * @label Fee
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-fee
     *
     * Note: This endpoint is broken.
     */
    // async getFee(this: Discojs, price: number, currency?: CurrenciesEnum) {
    //   let uri = `/marketplace/fee/${price}`
    //   if (currency) uri += `/${currency}`
    //   return this.fetcher.schedule<Fee>(uri)
    // }
    /**
     * Retrieve price suggestions for the provided Release ID.
     *
     * @remarks
     * Suggested prices will be denominated in the user’s selling currency.
     *
     * @category Marketplace
     * @label Price Suggestions
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-price-suggestions
     */
    async getPriceSuggestions(releaseId) {
        return this.fetcher.schedule(`/marketplace/price_suggestions/${releaseId}`);
    }
    /**
     * Retrieve marketplace statistics for the provided Release ID.
     *
     * @remarks
     * These statistics reflect the state of the release in the marketplace currently, and include the number of items currently for sale,
     * lowest listed price of any item for sale, and whether the item is blocked for sale in the marketplace.
     *
     *
     * @category Marketplace
     * @label Release Statistics
     *
     * @link https://www.discogs.com/developers#page:marketplace,header:marketplace-release-statistics
     */
    async getMarketplaceStatistics(releaseId, currency) {
        return this.fetcher.schedule(`/marketplace/stats/${releaseId}`, { currency });
    }
}

class UserCollection {
    /**
     * Retrieve a list of folders in a user’s collection.
     *
     * @remarks
     * If the collection has been made private by its owner, authentication as the collection owner is required.
     * If you are not authenticated as the collection owner, only folder ID 0 (the “All” folder) will be visible (if the requested user’s collection is public).
     *
     * @category User Collection
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection
     */
    async listFoldersForUser(username) {
        return this.fetcher.schedule(`/users/${username}/collection/folders`);
    }
    /**
     * Retrieve a list of folders in authenticated user’s collection.
     *
     * @category User Collection
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection
     */
    async listFolders() {
        const username = await this.getUsername();
        return this.listFoldersForUser(username);
    }
    /**
     * Create a new folder in authenticated user’s collection.
     *
     * @category User Collection
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection
     */
    async createFolder(name) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders`, {}, HTTPVerbsEnum.POST, { name });
    }
    /**
     * Retrieve metadata about a folder in a user’s collection.
     *
     * @remarks
     * If folder_id is not 0, authentication as the collection owner is required.
     *
     * @category User Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-folder
     */
    async getFolderForUser(username, folderId) {
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}`);
    }
    /**
     * Retrieve metadata about a folder in authenticated user’s collection.
     *
     * @category User Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-folder
     */
    async getFolder(folderId) {
        const username = await this.getUsername();
        return this.getFolderForUser(username, folderId);
    }
    /**
     * Edit a folder’s metadata.
     *
     * @remarks
     * Folders 0 and 1 cannot be renamed.
     *
     * @category User Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-folder
     */
    async editFolder(folderId, name) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}`, {}, HTTPVerbsEnum.POST, {
            name,
        });
    }
    /**
     * Delete a folder from a user’s collection.
     *
     * @remarks
     * A folder must be empty before it can be deleted.
     *
     * @category User Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-folder
     */
    async deleteFolder(folderId) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}`, {}, HTTPVerbsEnum.DELETE);
    }
    /**
     * View the user’s collection folders which contain a specified release. This will also show information about each release instance.
     *
     * @remarks
     * Authentication as the collection owner is required if the owner’s collection is private.
     *
     * @category User
     * @label Items By Release
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-release
     */
    async listItemsByReleaseForUser(username, release_id, pagination) {
        return this.fetcher.schedule(`/users/${username}/collection/releases/${release_id}`, paginate(pagination));
    }
    /**
     * View all user’s collection folders which contain a specified release. This will also show information about each release instance.
     *
     * @category User
     * @label Items By Release
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-release
     */
    listAllItemsByReleaseForUser(username, release_id) {
        return this.fetcher.createAllMethod((pagination) => this.listItemsByReleaseForUser(username, release_id, pagination));
    }
    /**
     * View authenticated user’s collection folders which contain a specified release. This will also show information about each release instance.
     *
     * @category User
     * @label Items By Release
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-release
     */
    async listItemsByRelease(release_id, pagination) {
        const username = await this.getUsername();
        return this.listItemsByReleaseForUser(username, release_id, pagination);
    }
    /**
     * View all authenticated user’s collection folders which contain a specified release. This will also show information about each release instance.
     *
     * @category User
     * @label Items By Release
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-release
     */
    listAllItemsByRelease(release_id) {
        return this.fetcher.createAllMethod((pagination) => this.listItemsByRelease(release_id, pagination));
    }
    /**
     * Returns the list of item in a folder in a user’s collection.
     *
     * @remarks
     * Basic information about each release is provided, suitable for display in a list. For detailed information, make another API call to fetch the corresponding release.
     * If folder_id is not 0, or the collection has been made private by its owner, authentication as the collection owner is required.
     * If you are not authenticated as the collection owner, only public notes fields will be visible.
     *
     * @category User
     * @label Collection Items By Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-folder
     */
    async listItemsInFolderForUser(username, folderId, sort, pagination) {
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}/releases`, {
            ...sortBy(UserSortEnum.ADDED, sort),
            ...paginate(pagination),
        });
    }
    /**
     * Returns all items in a folder in a user’s collection.
     *
     * @category User
     * @label Collection Items By Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-folder
     */
    listAllItemsInFolderForUser(username, folderId, sort) {
        return this.fetcher.createAllMethod((pagination) => this.listItemsInFolderForUser(username, folderId, sort, pagination));
    }
    /**
     * Returns the list of item in a folder in authenticated user’s collection.
     *
     * @remarks
     * Basic information about each release is provided, suitable for display in a list. For detailed information, make another API call to fetch the corresponding release.
     *
     * @category User
     * @label Collection Items By Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-folder
     */
    async listItemsInFolder(folderId, sort, pagination) {
        const username = await this.getUsername();
        return this.listItemsInFolderForUser(username, folderId, sort, pagination);
    }
    /**
     * Returns all items in a folder in authenticated user’s collection.
     *
     * @category User
     * @label Collection Items By Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-items-by-folder
     */
    listAllItemsInFolder(folderId, sort) {
        return this.fetcher.createAllMethod((pagination) => this.listItemsInFolder(folderId, sort, pagination));
    }
    /**
     * Add a release to a folder in authenticated user’s collection.
     *
     * @category User
     * @label Add To Collection Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-add-to-collection-folder
     */
    async addReleaseToFolder(releaseId, folderId = FolderIdsEnum.UNCATEGORIZED) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}/releases/${releaseId}`, {}, HTTPVerbsEnum.POST);
    }
    /**
     * Change the rating on a release.
     *
     * @category User
     * @label Change Rating Of Release
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-change-rating-of-release
     */
    async editReleaseInstanceRating(folderId, releaseId, instanceId, rating) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}/releases/${releaseId}/instances/${instanceId}`, {}, HTTPVerbsEnum.POST, { rating });
    }
    /**
     * Move the instance of a release to another folder.
     *
     * @category User
     * @label Change Rating Of Release
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-change-rating-of-release
     */
    async moveReleaseInstanceToFolder(oldFolderId, releaseId, instanceId, newFolderId) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${oldFolderId}/releases/${releaseId}/instances/${instanceId}`, {}, HTTPVerbsEnum.POST, { folderId: newFolderId });
    }
    /**
     * Remove an instance of a release from authenticated user’s collection folder.
     *
     * @category User
     * @label Delete Instance From Folder
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-delete-instance-from-folder
     */
    async deleteReleaseInstanceFromFolder(folderId, releaseId, instanceId) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}/releases/${releaseId}/instances/${instanceId}`, {}, HTTPVerbsEnum.DELETE);
    }
    /**
     * Retrieve a list of user-defined collection notes fields. These fields are available on every release in the collection.
     *
     * @remarks
     * If the collection has been made private by its owner, authentication as the collection owner is required.
     * If you are not authenticated as the collection owner, only fields with `public` set to true will be visible.
     *
     * @category User
     * @label List Custom Fields
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-list-custom-fields
     */
    async listCustomFieldsForUser(username) {
        return this.fetcher.schedule(`/users/${username}/collection/fields`);
    }
    /**
     * Retrieve a list of authenticated user-defined collection notes fields. These fields are available on every release in the collection.
     *
     * @category User
     * @label List Custom Fields
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-list-custom-fields
     */
    async listCustomFields() {
        const username = await this.getUsername();
        return this.listCustomFieldsForUser(username);
    }
    /**
     * Change the value of a notes field on a particular instance.
     *
     * @category User
     * @label Edit Fields Instance
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-edit-fields-instance
     */
    async editCustomFieldForInstance(folderId, releaseId, instanceId, fieldId, value) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/folders/${folderId}/releases/${releaseId}/instances/${instanceId}/fields/${fieldId}`, undefined, HTTPVerbsEnum.POST, { value });
    }
    /**
     * Returns the minimum, median, and maximum value of authenticated user’s collection.
     *
     * @requires authentication
     *
     * @category User
     * @label Collection Value
     *
     * @link https://www.discogs.com/developers#page:user-collection,header:user-collection-collection-value
     */
    async getCollectionValue() {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/collection/value`);
    }
}

class UserIdentity {
    /**
     * Retrieve basic information about the authenticated user.
     *
     * @remarks
     * You can use this resource to find out who you’re authenticated as, and it also doubles as a good sanity check to ensure that you’re using OAuth correctly.
     *
     * @category User Identity
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-identity
     */
    async getIdentity() {
        return this.fetcher.schedule('/oauth/identity');
    }
    /**
     * Retrieve authenticated user's username.
     *
     * @remarks
     * Used internally within methods that use `username` as a param.
     *
     * @category User Identity
     *
     * @protected
     */
    async getUsername() {
        const { username } = await this.getIdentity();
        return username;
    }
    /**
     * Retrieve user's profile by username.
     *
     * @remarks
     * If authenticated as the requested user, the `email` key will be visible, and the `num_list count` will include the user’s private lists.
     * If authenticated as the requested user or the user’s collection/wantlist is public, the `num_collection` / `num_wantlist` keys will be visible.
     *
     * @category User Profile
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-profile
     */
    async getProfileForUser(username) {
        return this.fetcher.schedule(`/users/${username}`);
    }
    /**
     * Retrieve authenticated user's profile.
     *
     * @category User Profile
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-profile
     */
    async getProfile() {
        const username = await this.getUsername();
        return this.getProfileForUser(username);
    }
    /**
     * Edit a user’s profile data.
     *
     * @category User Profile
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-profile
     */
    async editProfile(options) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}`, {}, HTTPVerbsEnum.POST, {
            username,
            ...options,
        });
    }
    /**
     * Retrieve a user’s submissions by username.
     *
     * @category User Submissions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-submissions
     */
    async getSubmissionsForUser(username, pagination) {
        return this.fetcher.schedule(`/users/${username}/submissions`, paginate(pagination));
    }
    /**
     * Retrieve all user’s submissions by username.
     *
     * @category User Submissions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-submissions
     */
    getAllSubmissionsForUser(username) {
        return this.fetcher.createAllMethod((pagination) => this.getSubmissionsForUser(username, pagination));
    }
    /**
     * Retrieve authenticated user’s submissions.
     *
     * @category User Submissions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-submissions
     */
    async getSubmissions(pagination) {
        const username = await this.getUsername();
        return this.getSubmissionsForUser(username, pagination);
    }
    /**
     * Retrieve all authenticated user’s submissions.
     *
     * @category User Submissions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-submissions
     */
    getAllSubmissions() {
        return this.fetcher.createAllMethod((pagination) => this.getSubmissions(pagination));
    }
    /**
     * Retrieve a user’s contributions by username.
     *
     * @category User Contributions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-contributions
     */
    async getContributionsForUser(username, sort, pagination) {
        return this.fetcher.schedule(`/users/${username}/contributions`, {
            ...sortBy(UserSortEnum.ADDED, sort),
            ...paginate(pagination),
        });
    }
    /**
     * Retrieve all user’s contributions by username.
     *
     * @category User Contributions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-contributions
     */
    getAllContributionsForUser(username, sort) {
        return this.fetcher.createAllMethod((pagination) => this.getContributionsForUser(username, sort, pagination));
    }
    /**
     * Retrieve authenticated user’s contributions.
     *
     * @category User Contributions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-contributions
     */
    async getContributions(sort, pagination) {
        const username = await this.getUsername();
        return this.getContributionsForUser(username, sort, pagination);
    }
    /**
     * Retrieve all authenticated user’s contributions.
     *
     * @category User Contributions
     *
     * @link https://www.discogs.com/developers#page:user-identity,header:user-identity-user-contributions
     */
    getAllContributions(sort) {
        return this.fetcher.createAllMethod((pagination) => this.getContributions(sort, pagination));
    }
}

class UserLists {
    /**
     * Returns user’s lists.
     *
     * @remarks
     * Private lists will only display when authenticated as the owner.
     *
     * @category User
     * @label Lists
     *
     * @link https://www.discogs.com/developers#page:user-lists,header:user-lists-user-lists
     */
    async getListsForUser(username, pagination) {
        return this.fetcher.schedule(`/users/${username}/lists`, paginate(pagination));
    }
    /**
     * Returns all user’s lists.
     *
     * @category User
     * @label Lists
     *
     * @link https://www.discogs.com/developers#page:user-lists,header:user-lists-user-lists
     */
    getAllListsForUser(username) {
        return this.fetcher.createAllMethod((pagination) => this.getListsForUser(username, pagination));
    }
    /**
     * Returns authenticated user’s lists.
     *
     * @category User
     * @label Lists
     *
     * @link https://www.discogs.com/developers#page:user-lists,header:user-lists-user-lists
     */
    async getLists(pagination) {
        const username = await this.getUsername();
        return this.getListsForUser(username, pagination);
    }
    /**
     * Returns all authenticated user’s lists.
     *
     * @category User
     * @label Lists
     *
     * @link https://www.discogs.com/developers#page:user-lists,header:user-lists-user-lists
     */
    getAllLists() {
        return this.fetcher.createAllMethod((pagination) => this.getLists(pagination));
    }
    /**
     * Returns items from a specified list.
     *
     * @remarks
     * Private lists will only display when authenticated as the owner.
     *
     * @category User
     * @label Lists
     *
     * @link https://www.discogs.com/developers#page:user-lists,header:user-lists-user-lists
     */
    async getListItems(listId) {
        return this.fetcher.schedule(`/lists/${listId}`);
    }
}

class UserWantlist {
    /**
     * Returns the list of releases in a user’s wantlist.
     * Basic information about each release is provided, suitable for display in a list.
     * For detailed information, make another API call to fetch the corresponding release.
     *
     * @remarks
     * If the wantlist has been made private by its owner, you must be authenticated as the owner to view it.
     * The `notes` field will be visible if you are authenticated as the wantlist owner.
     *
     * @category User
     * @label Wantlist
     *
     * @link https://www.discogs.com/developers#page:user-wantlist,header:user-wantlist-wantlist
     */
    async getWantlistForUser(username, pagination) {
        return this.fetcher.schedule(`/users/${username}/wants`, paginate(pagination));
    }
    /**
     * Returns all releases in a user’s wantlist.
     *
     * @category User
     * @label Wantlist
     *
     * @link https://www.discogs.com/developers#page:user-wantlist,header:user-wantlist-wantlist
     */
    getAllWantlistForUser(username) {
        return this.fetcher.createAllMethod((pagination) => this.getWantlistForUser(username, pagination));
    }
    /**
     * Returns the list of releases in authenticated user’s wantlist.
     * Basic information about each release is provided, suitable for display in a list.
     * For detailed information, make another API call to fetch the corresponding release.
     *
     * @category User
     * @label Wantlist
     *
     * @link https://www.discogs.com/developers#page:user-wantlist,header:user-wantlist-wantlist
     */
    async getWantlist(pagination) {
        const username = await this.getUsername();
        return this.getWantlistForUser(username, pagination);
    }
    /**
     * Returns all releases in authenticated user’s wantlist.
     *
     * @category User
     * @label Wantlist
     *
     * @link https://www.discogs.com/developers#page:user-wantlist,header:user-wantlist-wantlist
     */
    getAllWantlist() {
        return this.fetcher.createAllMethod((pagination) => this.getWantlist(pagination));
    }
    /**
     * Add a release to authenticated user’s wantlist.
     *
     * @category User
     * @label Add to wantlist
     *
     * @link https://www.discogs.com/developers#page:user-wantlist,header:user-wantlist-add-to-wantlist
     */
    async addToWantlist(releaseId, notes, rating) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/wants/${releaseId}`, { notes, rating }, HTTPVerbsEnum.PUT);
    }
    /**
     * Remove a release to authenticated user’s wantlist.
     *
     * @category User
     * @label Add to wantlist
     *
     * @link https://www.discogs.com/developers#page:user-wantlist,header:user-wantlist-add-to-wantlist
     */
    async removeFromWantlist(releaseId) {
        const username = await this.getUsername();
        return this.fetcher.schedule(`/users/${username}/wants/${releaseId}`, {}, HTTPVerbsEnum.DELETE);
    }
}

class Discojs {
    fetcher;
    userAgent;
    outputFormat;
    constructor(options) {
        this.fetcher = new Fetcher(options ?? {});
        this.userAgent = this.fetcher.userAgent;
        this.outputFormat = this.fetcher.outputFormat;
    }
    /**
     * Return currencies supported by Discogs.
     *
     * @category Helpers
     *
     * @static
     */
    static getSupportedCurrencies() {
        return Object.values(CurrenciesEnum);
    }
    /**
     * Return release conditions supported by Discogs.
     *
     * @category Helpers
     *
     * @static
     */
    static getReleaseConditions() {
        return Object.values(ReleaseConditionsEnum);
    }
    /**
     * Return slevve conditions supported by Discogs.
     *
     * @category Helpers
     *
     * @static
     */
    static getSleeveConditions() {
        return Object.values(SleeveConditionsEnum);
    }
    /**
     * Retrieve an image retrieved in another response.
     *
     * @requires authentication
     *
     * @category Helpers
     *
     * @link https://www.discogs.com/developers#page:images
     */
    async fetchImage(imageUrl) {
        return this.fetcher.schedule(imageUrl);
    }
}
applyMixins(Discojs, [
    UserIdentity,
    UserCollection,
    UserWantlist,
    UserLists,
    Database,
    MarketPlace,
    InventoryExport,
    InventoryUpload,
]);

export { AuthError, CommunityStatusesEnum, CurrenciesEnum, DataQualityEnum, DiscogsError, Discojs, EditOrderStatusesEnum, FolderIdsEnum, InventorySortEnum, InventoryStatusesEnum, ListingStatusesEnum, OrderMessageTypesEnum, OrderSortEnum, OrderStatusesEnum, ReleaseConditionsEnum, ReleaseSortEnum, SearchTypeEnum, SleeveConditionsEnum, SortOrdersEnum, UserSortEnum };
